import { injectGlobal } from 'styled-components';
import base from './base';
import reset from './reset';
import pagination from './pagination';


export default injectGlobal`
${reset}
${base}
${pagination}
`;



// WEBPACK FOOTER //
// ./src/components/styled/global/index.js